import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import AppFooterWhite from "./layout/AppFooterWhite";
import Index from "./views/Index.vue";

import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";

import Controller from "./views/Controller.vue";
import Flexyard from "./views/Flexyard.vue";
import Flextrim from "./views/Flextrim.vue";
import Flexdraw from "./views/Flexdraw.vue";
import Update from "./views/Update.vue";
import WebBase from "./views/WebBase.vue";
import Report from "./views/Report.vue";
import Computer from "./views/Computer.vue";
import About from "./views/About.vue";
import Contact from "./views/Contact.vue";
import Download from "./views/Download.vue";

import ProjectFlexyard from "./views/ProjectFlexyard.vue";
import ProjectFlextrim1 from "./views/ProjectFlextrim1.vue";
import ProjectFlextrim2 from "./views/ProjectFlextrim2.vue";
import ProjectFlextrim3 from "./views/ProjectFlextrim3.vue";
import ProjectFlextrim4 from "./views/ProjectFlextrim4.vue";
import ProjectFlextrim5 from "./views/ProjectFlextrim5.vue";
import ProjectFlextrim6 from "./views/ProjectFlextrim6.vue";
import ProjectFlextrim7 from "./views/ProjectFlextrim7.vue";
import ProjectFlextrim8 from "./views/ProjectFlextrim8.vue";


Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "index",
      components: {
        header: AppHeader,
        default: Index,
        footer: AppFooter
      }
    },
    {
      path: "/controller",
      name: "controller",
      components: {
        header: AppHeader,
        default: Controller,
        footer: AppFooter
      }
    },
    {
      path: "/flexyard",
      name: "flexyard",
      components: {
        header: AppHeader,
        default: Flexyard,
        footer: AppFooter
      }
    },
    {
      path: "/flextrim",
      name: "flextrim",
      components: {
        header: AppHeader,
        default: Flextrim,
        footer: AppFooter
      }
    },
    {
      path: "/flexdraw",
      name: "flexdraw",
      components: {
        header: AppHeader,
        default: Flexdraw,
        footer: AppFooterWhite
      }
    },
    {
      path: "/download",
      name: "download",
      components: {
        header: AppHeader,
        default: Download,
        footer: AppFooter
      }
    },
    {
      path: "/about",
      name: "about",
      components: {
        header: AppHeader,
        default: About,
        footer: AppFooter
      }
    },
    {
      path: "/contact",
      name: "contact",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooterWhite
      }
    },
    {
      path: "/update",
      name: "update",
      components: {
        header: AppHeader,
        default: Update,
        footer: AppFooter
      }
    },
    {
      path: "/report",
      name: "report",
      components: {
        header: AppHeader,
        default: Report,
        footer: AppFooter
      }
    },
    {
      path: "/computer",
      name: "computer",
      components: {
        header: AppHeader,
        default: Computer,
        footer: AppFooter
      }
    },
    {
      path: "/webBase",
      name: "webBase",
      components: {
        header: AppHeader,
        default: WebBase,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlexyard",
      name: "projectFlexyard",
      components: {
        header: AppHeader,
        default: ProjectFlexyard,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlextrim1",
      name: "projectFlextrim1",
      components: {
        header: AppHeader,
        default: ProjectFlextrim1,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlextrim2",
      name: "projectFlextrim2",
      components: {
        header: AppHeader,
        default: ProjectFlextrim2,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlextrim3",
      name: "projectFlextrim3",
      components: {
        header: AppHeader,
        default: ProjectFlextrim3,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlextrim4",
      name: "projectFlextrim4",
      components: {
        header: AppHeader,
        default: ProjectFlextrim4,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlextrim5",
      name: "projectFlextrim5",
      components: {
        header: AppHeader,
        default: ProjectFlextrim5,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlextrim6",
      name: "projectFlextrim6",
      components: {
        header: AppHeader,
        default: ProjectFlextrim6,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlextrim7",
      name: "projectFlextrim7",
      components: {
        header: AppHeader,
        default: ProjectFlextrim7,
        footer: AppFooter
      }
    },
    {
      path: "/projectFlextrim8",
      name: "projectFlextrim8",
      components: {
        header: AppHeader,
        default: ProjectFlextrim8,
        footer: AppFooter
      }
    },
    {
      path: "/components",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
